import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import {
  BootAttemptSuccess,
  BootAttemptFailed,
  BootAttempt,
} from "../actions/boot";
import { EBootActions } from "../actions/boot";
import { map, tap, switchMap } from "rxjs/operators";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { ApiService } from "../../services/api/api.service";
import {
  LoginAttemptSuccess,
  LoginAttemptFailed,
  MeRequest,
} from "../actions/user";
import { IUser } from "src/app/models/user";
import {
  FetchAuctionStatusesAttempt,
  FetchRealEstateTypesAttempt,
} from "../actions/shared.action";

@Injectable()
export class BootEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private apiService: ApiService,
    private http: HttpClient,
  ) {}

  @Effect()
  Boot$ = this.actions$.pipe(
    ofType<BootAttempt>(EBootActions.BootAttempt),
    switchMap(() => {
      //THIS IS TEMPORARY MESS :D
      const dispatches: Array<any> = [];
      const errors: Array<any> = [];

      try {
        const LsData = localStorage.getItem("auth");
        const token = JSON.parse(LsData);
        //Todo Validate Token data structure...
        if (token) {
          dispatches.push(
            new LoginAttemptSuccess({
              data: token,
              authenticating: true,
              authenticated: true,
              errors: [],
            }),
          );
        }
      } catch (error) {
        dispatches.push(
          new LoginAttemptFailed({
            data: null,
            me: null,
            authenticated: false,
            authenticating: false,
            errors: ["Token Expired"],
          }),
        );
      }

      dispatches.push(new BootAttemptSuccess({ status: true, errors: [] }));
      dispatches.push(new FetchRealEstateTypesAttempt());
      dispatches.push(new FetchAuctionStatusesAttempt());

      return errors.length
        ? [new BootAttemptFailed({ status: false, errors: errors })]
        : dispatches;
    }),
  );

  @Effect({ dispatch: false })
  BootFailed$ = this.actions$.pipe(
    ofType<BootAttemptFailed>(EBootActions.BootAttemptFailed),
    map((action) => action),
    tap((data) => {
      //..
    }),
  );
}
